import React from "react";
import "./accountboxtwo.css";
import { Link } from "react-router-dom";

function AccountBoxTwo(props) {
  return (
    <div onMouseLeave={() => props.click()}>
      <div className="account-cardinsights center box1_hover_res" >
        <div className="account-name">
          {/* <span className="center">{sessionStorage.getItem("username")}</span> */}
        </div>
        <div style={{ marginBottom: "2rem" }} className="left">
          <a href="/dashboard/view_apply_jobs" className="no-dec">
            <div className="box-label flex-left pointer">
              <i className="material-icons">account_circle</i>
              <span style={{ marginLeft: "0.5rem" }} className="ml-3 box1_text">
                My Dashboard
              </span>
            </div>
            
          </a>
      

          {/* <div className="pointer flex-left box-label">
                <span className="no-dec ml-3" onClick={logout}>
                  Log out
                </span>
              </div> */}
        </div>
      </div>
    </div>
  );
}

export default AccountBoxTwo;
